<script>
  import { Loader, Badge } from "@gl/design-system";
  import { onMount } from "svelte";
  import { _ } from "../../stores/index";
  import { UsersRepository } from "../../repositories";
  import { format } from "date-fns";

  let loading = true;

  let user;

  async function fetchMe() {
    loading = true;
    try {
      user = await UsersRepository.me();
    } finally {
      loading = false;
    }
  }

  onMount(() => {
    fetchMe();
  });
</script>

<svelte:head>
  <title>
    {$_("users.me.profile")} | {$_("access-manager")}
  </title>
</svelte:head>

{#if loading}
  <Loader />
{:else}
  <div class="w-100 user-main-card">
    <div class="user-row" id="user-name">
      <div class="user-title">
        {$_("common.name")}
      </div>
      <div class="user-td">
        {`${user.data.firstName} ${user.data.lastName}`}
      </div>
    </div>

    <div class="user-row" id="user-email">
      <div class="user-title">
        {$_("users.email_address")}
      </div>
      <div class="user-td">
        {user.data.email}
      </div>
    </div>

    <div class="user-row" id="user-groups">
      <div class="user-title">
        {$_("common.groups")}
      </div>
      <div class="user-td" style="display: block">
        {#if user.groups?.length > 0}
          {#each user.groups as group}
            <p class="mb-2" style="">{group}</p>
          {/each}
        {:else}
          -
        {/if}
      </div>
    </div>
    <div class="user-row" id="user-roles">
      <div class="user-title">
        {$_("common.roles")}
      </div>
      <div class="user-td" style="display: block">
        {#if user.roles?.length > 0}
          {#each user.roles as role}
            <p class="mb-2" style="">{role}</p>
          {/each}
        {:else if user.data.isMaster}
          <Badge
            class={user.roles > 0 && "mt-2"}
            status="success"
            label={$_("users.master")}
          />
        {:else}
          -
        {/if}
      </div>
    </div>

    {#if user.data?.expiration}
      <div class="user-row" id="user-created">
        <div class="user-title">
          {$_("account.expiration")}
        </div>
        <div class="user-td">
          {format(new Date(user.data.expiration), "dd.MM.yyyy")}
        </div>
      </div>
    {/if}
  </div>
{/if}
